// pages/admin/components/AdminSidebar.js
import React from 'react';
import { useAdmin } from '../../../contexts/AdminContext';

const AdminSidebar = ({ visible, currentPage, onNavigate, onToggle, isMobile }) => {
  const { logout, currentUser } = useAdmin();

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: 'fas fa-tachometer-alt'
    },
    {
      id: 'users',
      label: 'Users',
      icon: 'fas fa-users'
    },
    {
      id: 'inheritances',
      label: 'Inheritances',
      icon: 'fas fa-hand-holding-heart'
    },
    {
      id: 'activity',
      label: 'Activity Logs',
      icon: 'fas fa-chart-line'
    },
    {
      id: 'settings',
      label: 'System Settings',
      icon: 'fas fa-cog'
    }
  ];

  const handleLogout = () => {
    logout();
  };

  return (
    <>
      {/* Backdrop for mobile */}
      {isMobile && visible && (
        <div className="admin-sidebar-backdrop" onClick={onToggle}></div>
      )}
      
      <div className={`admin-sidebar ${visible ? 'visible' : ''}`}>
        <div className="admin-sidebar-header">
          <div className="admin-logo-placeholder">
            <i className="fas fa-shield-alt"></i>
          </div>
          <h2>PhenixLoc</h2>
        </div>

        <nav className="admin-sidebar-nav">
          <ul>
            {menuItems.map(item => (
              <li 
                key={item.id}
                className={currentPage === item.id ? 'active' : ''}
                onClick={() => onNavigate(item.id)}
              >
                <a href="#" onClick={(e) => e.preventDefault()}>
                  <i className={item.icon}></i>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="admin-sidebar-footer">
          {currentUser && (
            <div className="admin-user-info">
              <div className="admin-user-avatar">
                <i className="fas fa-user-circle"></i>
              </div>
              <div className="admin-user-details">
                <span className="admin-username">{currentUser.username}</span>
                <span className="admin-user-role">{currentUser.role}</span>
              </div>
            </div>
          )}
          <button 
            className="admin-logout-btn"
            onClick={handleLogout}
            title="Logout"
          >
            <i className="fas fa-sign-out-alt"></i>
            Logout
          </button>
        </div>
      </div>
    </>
  );
};

export default AdminSidebar;